export const CART_ROUTE_PATH = "/cart";
export const CHECKOUT_PATH = "/checkout";
export const ORDER_CONFIRMATION_ROUTE_PATH = "/order-confirmation";
export const ARTWORK_UPLOAD_ROUTE_PREFIX = "/artwork-upload/";
export const PROOF_ROUTE_PREFIX = "/proof/";
export const PRIVACY_PATH = "/privacy";
export const ACCESSIBILITY_PATH = "/accessibility";
export const PRODUCT_DESIGNER_PREVIEW_PATH = "/product-designer-preview";
export const PVC_SIGN_ROUTE_PATH = "/pvc-sign";
